/** Shared schedule helpers — Tracking Info and ShipmentCard must read the same fields. */

export function toDayMs(raw) {
  if (raw == null || raw === '') return null;
  const s = String(raw).trim();
  if (!s) return null;
  const iso = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (iso) {
    const [y, m, d] = iso[1].split('-').map(Number);
    return new Date(y, m - 1, d).getTime();
  }
  const dt = new Date(s);
  if (Number.isNaN(dt.getTime())) return null;
  return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()).getTime();
}

/** ShipsGo predicted discharge. Never customs `eta` first. */
export function predictedEta(row) {
  if (!row) return null;
  return row.estimated_arrival || row.eta_updated || row.eta_initial || row.eta || null;
}

/** clamp(0,100, round((today - ETD) / (ETA - ETD) * 100)).
 *  Null only when a date is missing. 0 when both dates exist but the window
 *  has not started or ETA <= ETD — so every stop with a timeline shows 0%, not a mix of — and 0%. */
export function timelinePct(etd, eta) {
  const etdMs = toDayMs(etd);
  const etaMs = toDayMs(eta);
  if (etdMs == null || etaMs == null || !Number.isFinite(etaMs)) return null;
  if (etaMs <= etdMs) return 0;
  const now = new Date();
  const todayMs = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  return Math.max(0, Math.min(100, Math.round(((todayMs - etdMs) / (etaMs - etdMs)) * 100)));
}

export function formatEtaDate(raw, withTime = false) {
  if (raw == null || raw === '') return null;
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) {
    return String(raw).slice(0, withTime ? 16 : 10);
  }
  const date = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  if (!withTime) return date;
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  return `${date}, ${time}`;
}
